import { gqlClient } from '@/api/graphql-client';
import estimateKeys from '@/api/queries/estimates/keyFactory';
import { graphql } from '@/gql';
import { EstimateCategory } from '@/gql/graphql';
import { useQuery } from '@tanstack/react-query';

const GetEstimateDefaultItemsQuery = graphql(`
  query GetEstimateDefaultItems($category: EstimateCategory!) {
    estimateDefaultItems(category: $category) {
      id
      category
      quantity
      lineItem {
        id
        name
        description
        price {
          unitPriceExcTax {
            value
            currency {
              code
              exponent
            }
          }
        }
      }
    }
  }
`);

const useGetEstimateDefaultItems = (category: EstimateCategory) => {
  const { data, ...rest } = useQuery({
    queryKey: estimateKeys.estimateDefaultItems(category),
    queryFn: () => {
      return gqlClient.request(GetEstimateDefaultItemsQuery, {
        category,
      });
    },
    meta: { errorMessage: 'Failed to load default estimate items' },
  });

  return {
    estimateDefaultItems: data?.estimateDefaultItems,
    ...rest,
  };
};

export default useGetEstimateDefaultItems;
